import { render, staticRenderFns } from "./CannotAddWidgetAlertInSlide.vue?vue&type=template&id=5e860884&"
import script from "./CannotAddWidgetAlertInSlide.vue?vue&type=script&lang=js&"
export * from "./CannotAddWidgetAlertInSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports